import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import SubHeading from '../SubHeading/index.js';
import Box from '../Box/index.js';
function TimelineItem(_ref) {
  let {
    label,
    value
  } = _ref;
  return /*#__PURE__*/_jsx("li", {
    className: "timeline-item",
    "data-cmp": "timelineItem"
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: "timeline-label"
  }, void 0, label), /*#__PURE__*/_jsx("span", {
    className: "timeline-value"
  }, void 0, value));
}
function Timeline(_ref2) {
  let {
    data = [],
    header = '',
    ...rest
  } = _ref2;
  if (data.length === 0) return null;
  return /*#__PURE__*/React.createElement(Box, Object.assign({
    backgroundColor: "neutral-primary-transparent-40",
    "data-cmp": "timeline"
  }, rest), /*#__PURE__*/_jsx(SubHeading, {
    level: 3,
    className: "margin-bottom-4"
  }, void 0, header), /*#__PURE__*/_jsx("ol", {
    className: "timeline"
  }, void 0, data.map((item, key) => /*#__PURE__*/_jsx(TimelineItem, {
    label: item.label,
    value: item.value
  }, key))));
}
export default Timeline;